export const UPDATED: string                = import.meta.env.VITE_UPDATED;

export const API_URL: string                = import.meta.env.VITE_API_URL;

export const AUTH_URL: string               = import.meta.env.VITE_AUTH_URL ?? 'https://auth.cirqll.nl/oauth/authorize';
export const OAUTH_CLIENT_ID: string        = import.meta.env.VITE_OAUTH_CLIENT_ID;
export const OAUTH_REDIRECT_URI: string     = `${window.location.origin}/auth/callback`;
export const OAUTH_MOBILE_CLIENT_ID: string    = import.meta.env.VITE_OAUTH_MOBILE_CLIENT_ID;
export const OAUTH_MOBILE_REDIRECT_URI: string = 'https://app.cirqll.nl/oauth/mobile-callback';

export const CUSTOMER_TOTALS_ENABLED        = import.meta.env.VITE_CUSTOMER_TOTALS_ENABLED === 'true';
export const CUSTOMER_GOOGLE_SEARCH_ENABLED = import.meta.env.VITE_CUSTOMER_GOOGLE_SEARCH_ENABLED === 'true';
export const NOTE_FIELDS_ENABLED            = import.meta.env.VITE_NOTE_FIELDS_ENABLED === 'true';
export const NOTE_OVERVIEW_ENABLED_ON_MOBILE = import.meta.env.VITE_NOTE_OVERVIEW_ENABLED_ON_MOBILE === 'true';
export const INTERCOM_ID                    = import.meta.env.VITE_INTERCOM_ID as string|undefined;
export const GOLD_NAV                       = import.meta.env.VITE_GOLD_NAV === 'true';
export const GOOGLE_API_KEY                 = import.meta.env.VITE_GOOGLE_API_KEY as string|undefined;
export const COLOR_THEMES                   = (import.meta.env.VITE_COLOR_THEMES as string ?? 'light,dark').split(',');
